module.exports = __webpack_public_path__ + "img/avatar-s-11.1a620230.jpg";